export const regulations = {
  hero: {
    title: 'RACE REGULATIONS',
    subtitle: 'Official rules and information for SINJAVINA SKYRACE 2026',
  },
  overview: {
    title: 'RACE INFORMATION',
    subtitle: 'Two races, one starting point',
    race1: 'SINJAVINA SKYRACE: 40km with 2000m D+',
    race2: 'SINJAVINA MINI SKYRACE: 10km with 1000m D+',
    tableHeaders: {
      detail: 'Detail',
      information: 'Information',
    },
    startLocation: 'Start Location',
    startLocationValue: 'Motel Ravnjak, Selo Bistrica, Mojkovac',
    startCoordinates: 'Start Coordinates',
    miniFinish: 'Mini Skyrace Finish',
    miniFinishValue: 'Zabojsko Lake (Eko Koliba)',
    miniFinishCoords: 'Mini Finish Coordinates',
    skyraceFinish: 'Skyrace Finish',
    skyraceFinishValue: 'Town Square, Mojkovac',
    skyraceFinishCoords: 'Skyrace Finish Coordinates',
    miniMaxAlt: 'Mini Max Altitude',
    skyraceMaxAlt: 'Skyrace Max Altitude',
  },
  aidStations: {
    title: 'AID STATIONS & TIME GATES',
    miniTitle: 'SINJAVINA MINI SKYRACE',
    skyraceTitle: 'SINJAVINA SKYRACE',
    aidStation: 'Aid Station Available',
    finish: 'FINISH',
    finalCutoff: 'FINAL CUTOFF',
  },
  schedule: {
    title: 'RACE WEEKEND SCHEDULE',
    friday: 'FRIDAY, JUNE 5, 2026',
    saturday: 'SATURDAY, JUNE 6, 2026',
    bibCollection: 'Bib Collection in Mojkovac',
    locationTBA: '(Location to be announced)',
    busTransport: 'Bus from Mojkovac to Start (Bistrica)',
    reservation: 'Reservation: +382 68/898-636 or sinjavinaskyrace@gmail.com',
    bibAtStart: 'Bib Collection at Start (Motel Ravnjak)',
    raceStart: 'RACE START',
    finalCutoff: 'Final Cutoff for SINJAVINA SKYRACE',
  },
  registrationInfo: {
    title: 'REGISTRATION INFORMATION',
    method: 'Registration is exclusively online through Avaibook platform',
    period: 'Period',
    skyrace: 'Skyrace',
    miniSkyrace: 'Mini Skyrace',
    early: 'Early (Until March 1)',
    standard: 'Standard (Until April 30)',
    late: 'Late (Until May 15)',
    warning: 'Registration closes on May 15, 2026. No on-site registration available.',
  },
  refund: {
    title: 'REFUND POLICY',
    point1: 'Refunds are only possible if the event is cancelled due to organizer negligence. In case of force majeure, no refunds will be issued.',
    point2: 'The organizer reserves the right to change the time or date of the race without refund.',
    point3: 'The organizer may stop the race in case of unforeseen circumstances that endanger participant safety, and in this case refunds will not be provided.',
  },
  cta: {
    question: 'Questions about the regulations?',
    button: 'GO TO REGISTRATION',
  },
};